<template>
    <div class="cute-root">
        <div v-if="loading" class="w-100">
            <Spinner class="loading-spinner mt-5" />
        </div>
        <div
            v-else-if="!hasCompletedProfile"
            class="w-100 d-flex flex-column align-items-center pb-5"
        >
            <img
                :src="profileSvg"
                style="display:block;margin:auto;width:200px;height:200px;object-fit:scale-down;margin-top:40px;"
            />
            <h6 class="text-center mb-4">
                {{ $t('tests.completedYourProfile') }}
            </h6>
            <BaseButton variant="primary" @click="toProfile">
                {{ $t('tests.toMyProfile') }}
            </BaseButton>
        </div>
        <Dashboard v-else-if="hasTestData" :testData="testData" />
        <div v-else class="pb-5">
            <img
                :src="emptySvg"
                style="display:block;margin:auto;width:200px;height:200px;object-fit:scale-down;margin-top:40px;"
            />
            <h6 class="text-center mb-0">{{ $t('tests.unauthorized') }}</h6>
        </div>
    </div>
</template>

<script>
// Project components
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';

// Components
import Dashboard from './components/Dashboard';

// Assets
import EmptySvg from '~/assets/img/empty.svg';
import ProfileSvg from '~/assets/img/profile.svg';

// Utils
import {
    maxPossibleScore,
    getCurrentScore,
} from '~/utils/mappers/mapProfileToActions';

export default {
    name: 'Cute',
    components: { MainLayout, ProfileModule, Dashboard },
    data: () => ({
        emptySvg: EmptySvg,
        profileSvg: ProfileSvg,
        testData: null,
        error: null,

        isLoading: true,
    }),
    computed: {
        hasTestData() {
            return Boolean(this.testData && this.testData.link);
        },
        user() {
            return this.$interfaces.user.me.get({
                reactive: true,
            });
        },
        candidate() {
            return this.$interfaces.candidate.me.get({
                reactive: true,
            });
        },
        loading() {
            return (
                this.isLoading || this.userLoading() || this.candidateLoading()
            );
        },
        hasCompletedProfile() {
            const userData = this.userData() || {};
            const profileData = this.candidateData() || {
                languages: [],
                degrees: [],
            };
            return getCurrentScore(userData, profileData) >= maxPossibleScore;
        },
    },
    methods: {
        fetchCuteTest() {
            this.isLoading = true;
            // Get cute test
            this.$interfaces.candidate.test['cut-e']
                .get({
                    forceUpdate: true,
                })
                .then(data => {
                    this.testData = data.data;
                })
                .catch(err => {
                    this.err = err;
                })
                .finally(() => (this.isLoading = false));
        },
        updateTestDataConsent() {
            if (this.testData) {
                this.testData.consented = true;
            }
        },
        userLoading() {
            return this.user.loading;
        },
        userData() {
            return this.user.data;
        },
        candidateLoading() {
            return this.candidate.loading;
        },
        candidateData() {
            return this.candidate.data;
        },
        toProfile() {
            this.$router.push(this.$URLS.spotlight);
        },
    },
    mounted() {
        this.fetchCuteTest();
    },
};
</script>

<style scoped>
.cute-root {
    margin-bottom: 200px;
}

.loading-spinner {
    display: block;
    margin: auto;
}
</style>
